import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { MobileAuthContext } from '../context/MobileAuthContext';

/**
 * useCurrentIndustry — single source of truth for the active tenant's industry.
 *
 * Works on both portals:
 *  - Desktop (AuthProvider):  industry comes from `user.industry`
 *  - Mobile  (MobileAuthProvider): industry comes from `operator.tenant_industry`
 *
 * Safe to call from any component: if neither provider is mounted (or neither
 * has loaded yet), returns `null` so callers can guard with `=== 'crane_hire'`
 * without crashing.
 *
 * Companion helper `useIsCraneHire()` is exported for the common case.
 */
export const useCurrentIndustry = () => {
  const desktopAuth = useContext(AuthContext);
  const mobileAuth = useContext(MobileAuthContext);
  return (
    desktopAuth?.user?.industry ??
    mobileAuth?.operator?.tenant_industry ??
    null
  );
};

export const useIsCraneHire = () => useCurrentIndustry() === 'crane_hire';

export const useIsConcretePumping = () => useCurrentIndustry() === 'concrete_pumping';

export const useIsStreetSweeping = () => useCurrentIndustry() === 'street_sweeping';
